module.exports = __webpack_public_path__ + "static/media/04_amis.1632f10c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/StickyPhone/medias/04_amis.mp4
// module id = 200
// module chunks = 0